import React, { useEffect, useState } from "react";
// import GradientButton from "../../Components/Button/GradientButton";
import ButtonGroupPortfolio from "../../Components/Profile/ButtonGroup";
import PersonalInformation from "../../Components/Profile/PersonalInformation";
import Achievements from "../../Components/Profile/Achievements";
import PrivacyManagement from "../../Components/Profile/PrivacyManagement";
import CvCustomization from "../../Components/Profile/CvCustomization";
import ReferTalentOrSME from "../../Components/Profile/ReferTalentOrSME";
import RedeemCredits from "../../Components/Profile/RedeemCredits";
import Survey from "../../Components/Profile/Survey";
import { useLocation } from "react-router-dom";

const UserIcon = ({ color = "#F1F3F4" }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="6.75"
      cy="5.25"
      r="3"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.25 15.75V14.25C2.25 12.5931 3.59315 11.25 5.25 11.25H8.25C9.90685 11.25 11.25 12.5931 11.25 14.25V15.75"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 2.34766C13.3274 2.68753 14.2559 3.88365 14.2559 5.25391C14.2559 6.62416 13.3274 7.82028 12 8.16016"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.75 15.7508V14.2508C15.7422 12.8892 14.8184 11.7037 13.5 11.3633"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AchievementsIcon = ({ color = "#8F8F8F" }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.75 2.25H11.25L13.5 7.5L9 9L4.5 7.5L6.75 2.25Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 9L6.75 2.25"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.25 8.25L9 2.25"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 14.625L6.75 15.75L7.125 13.125L5.625 11.625L7.875 11.25L9 9L10.125 11.25L12.375 11.625L10.875 13.125L11.25 15.75L9 14.625Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const RedeemCreditIcon = ({ color = "#8F8F8F" }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="9"
      cy="9"
      r="6.75"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1 6.75085C10.8232 6.27061 10.304 5.9822 9.75 6.00085H8.25C7.42157 6.00085 6.75 6.67243 6.75 7.50085C6.75 8.32928 7.42157 9.00085 8.25 9.00085H9.75C10.5784 9.00085 11.25 9.67243 11.25 10.5009C11.25 11.3293 10.5784 12.0009 9.75 12.0009H8.25C7.69599 12.0195 7.17685 11.7311 6.9 11.2509"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 4.5C9.75 4.08579 9.41421 3.75 9 3.75C8.58579 3.75 8.25 4.08579 8.25 4.5H9.75ZM8.25 6C8.25 6.41421 8.58579 6.75 9 6.75C9.41421 6.75 9.75 6.41421 9.75 6H8.25ZM9.75 12C9.75 11.5858 9.41421 11.25 9 11.25C8.58579 11.25 8.25 11.5858 8.25 12H9.75ZM8.25 13.5C8.25 13.9142 8.58579 14.25 9 14.25C9.41421 14.25 9.75 13.9142 9.75 13.5H8.25ZM8.25 4.5V6H9.75V4.5H8.25ZM8.25 12V13.5H9.75V12H8.25Z"
      fill={color}
    />
  </svg>
);

const SurveysIcon = ({ color = "#8F8F8F" }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 3.75H5.25C4.42157 3.75 3.75 4.42157 3.75 5.25V14.25C3.75 15.0784 4.42157 15.75 5.25 15.75H12.75C13.5784 15.75 14.25 15.0784 14.25 14.25V5.25C14.25 4.42157 13.5784 3.75 12.75 3.75H11.25"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="6.75"
      y="2.25"
      width="4.5"
      height="3"
      rx="1.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75016 9H6.75766"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 9H11.25"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75016 12H6.75766"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 12H11.25"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const tabs = [
  { id: 1, Icon: UserIcon, name: "Personal Information" },
  { id: 2, Icon: AchievementsIcon, name: "M3 Achievements" },
  { id: 3, Icon: RedeemCreditIcon, name: "Redeem Credits" },
  { id: 4, Icon: SurveysIcon, name: "Surveys" },
];

const Portfolio = () => {
  const location = useLocation();

  const personalInformationTab = location?.state && location?.state?.tab;
  console.log({ personalInformationTab });
  let currentDisplayJsx = <p>Work on this Tab</p>;
  const [selectedtab, setSelectedTab] = useState(tabs[0].id);

  if (selectedtab === tabs[0].id) {
    currentDisplayJsx = (
      <PersonalInformation personalInformationTab={personalInformationTab} />
    );
  }
  // else if (selectedtab === tabs[1].id) {
  //   currentDisplayJsx = <Achievements />;
  // } else if (selectedtab === tabs[2].id) {
  //   currentDisplayJsx = <RedeemCredits />;
  // } else if (selectedtab === tabs[3].id) {
  //   currentDisplayJsx = <Survey />;
  // }
  return (
    <div>
      {/* <ButtonGroupPortfolio
        tabs={tabs}
        selectedtab={selectedtab}
        setSelectedTab={setSelectedTab}
      /> */}
      <div className="">{currentDisplayJsx}</div>
      {/* <div className="flex flex-col gap-4 max-w-[340px]">
          <PrivacyManagement />
          <CvCustomization />
          <ReferTalentOrSME /> 
        </div> */}
    </div>
  );
};

export default Portfolio;
